import { storeToRefs } from 'pinia';
import { privilegesStore } from '@/stores/privileges-store';

const usePrivilegesStore = () => {
    const { privileges } = storeToRefs(privilegesStore());

    return {
        privileges
    };
};

export { usePrivilegesStore };
